import React from 'react';
import {WarningIcon} from "@chakra-ui/icons";
import styles from './AlertForCreator.css';
import docs from '../utils/docs.json'


const AlertForCreator = () => {
    return (
        <div className='alert_root'>
            <a className='alert_documentation' href={docs?.full?.docs} target="_blank" rel="noreferrer">
                <div className='alert_header_root'>
                    <WarningIcon w={8} h={8} color="red.500"/>
                    <h2 className='alert_title'>LEGGERE ATTENTAMENTE PRIMA DELL'UTILIZZO</h2>
                </div>
                <div className='alert_content_root'>
                    <p>Prima di utilizzare il form qui presente si prega di leggere la documentazione sviluppata</p>
                </div>
            </a>
        </div>
    );
};


export default AlertForCreator;
